import { type RouteRecordRaw } from 'vue-router'
import { EcpayPaymentPage } from '@myorg/report-lib'
import { ROUTES, API_ENDPOINTS, EcpayPaymentApi, PaymentPaginatedRequest, PaymentPaginatedResponse } from '@myorg/type-lib'
import { api } from '../../services/api'

export const ecpayApiImpl: EcpayPaymentApi = {
  getMerchantPaymentInfo: async () => {
    // 對應 ecpay-helper-service 的 API 路徑
    const res = await api().get(API_ENDPOINTS.ECPAY.MERCHANT_PAYMENT_INFO)
    return res.data
  },
  getMerchantPaymentInfoPaginated: async (params?: PaymentPaginatedRequest): Promise<PaymentPaginatedResponse> => {
    // 對應 ecpay-helper-service 的分頁 API 路徑
    // 支援分頁與 RtnCode 篩選，預設使用 rtn_code == '-1' 篩選，若不帶參數則撈全部
    const queryParams: any = {}
    if (params?.page) queryParams.page = params.page
    if (params?.limit) queryParams.limit = params.limit
    // 預設使用 rtn_code == '-1' 篩選，若明確傳入 undefined 或空字串則不篩選
    if (params?.rtn_code !== undefined && params.rtn_code !== '') {
      queryParams.rtn_code = params.rtn_code
    }
    const res = await api().get(API_ENDPOINTS.ECPAY.MERCHANT_PAYMENT_INFO_PAGINATED, { params: queryParams })
    return res.data
  },
  createInvoice: async (data) => {
    const res = await api().post(API_ENDPOINTS.BFF.CREATE_INVOICE, data)
    return res.data
  },
  queryCompanyName: async (ubn) => {
    const res = await api().get(API_ENDPOINTS.ECPAY.QUERY_COMPANY_NAME(ubn))
    return res.data
  },
  voidPayment: async (data) => {
    const res = await api().post(API_ENDPOINTS.BFF.VOID_PAYMENT, data)
    return res.data
  }
}

export const EcpayPaymentRoute: RouteRecordRaw = {
  path: ROUTES.ECPAY.PATH,
  name: ROUTES.ECPAY.NAME,
  component: EcpayPaymentPage,
  props: {
    ecpayApi: ecpayApiImpl
  }
}
